import React, { useEffect, useState, useRef, createContext, useContext } from 'react';
import 'leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import BarChart from './votesChart';
import { county } from './county';
import { vizContext } from './Nav';
import Switch from '@mui/material/Switch';
import './styles.css'
import layersicon from './Images/layers2.png';
import sat from './Images/sat.png';
import OSM from './Images/OSM.png';
import NGeo from './Images/NatGeo.PNG';


export const ChartContext = createContext();
export default function Map() {
  const viz = useContext(vizContext);
  const [visibility, setVisibility] = useState('hidden');
  const [chartHeight, setChartHeight] = useState('0px');
  const [chartWidth, setChartWidth] = useState('320px');
  const [chartVisibilty, setChartVisibilty] = useState('none')
  const [chartData, setChartData] = useState(["Total(%)", 50.49, 48.85, 0.44, 0.23])
  const [layerWidth,setLayerWidth]=useState('0px')
  const [layerOpacity,setLayerOpacity]=useState('0');
  const map = useRef(null);
  const BaseMap = useRef(null);
  const choro = useRef(null);
  const zoom = useRef(null)
  const div = useRef(null);
  const div2 = useRef(null);


  function MapInfo(a) {
    let VArr = [];

    if (a === 1) {
      for (let i = 0; i < county.features.length; i++) {
        VArr.push(county.features[i].properties.Ruto)
        console.log(VArr[i]);
      }
    } else if (a === 2) {
      for (let i = 0; i < county.features.length; i++) {
        VArr.push(county.features[i].properties.Odinga)
      }
    } else if (a === 3) {
      for (let i = 0; i < county.features.length; i++) {
        VArr.push(county.features[i].properties.Wajackoyah)
      }
    } else if (a === 4) {
      for (let i = 0; i < county.features.length; i++) {
        VArr.push(county.features[i].properties.Waihiga)
      }
    } else if (a === 5) {
      for (let i = 0; i < county.features.length; i++) {
        VArr.push(county.features[i].properties.Total)
      }
    } else if (a === 6) {
      for (let i = 0; i < county.features.length; i++) {
        VArr.push(county.features[i].properties.Registered)
      }
    }
    return VArr;
  }


  var Array = MapInfo(viz);
  const OSM_TILE = L.tileLayer(`https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png`, {
    attribution: '© OpenStreetMap'
  });

  const satellite = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
    attribution: 'Tiles &copy; Esri'
  });

  const NatGeo = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/NatGeo_World_Map/MapServer/tile/{z}/{y}/{x}', {
    attribution: 'Tiles &copy; Esri &mdash; National Geographic'
  })
  // const Labels = L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager_only_labels/{z}/{x}/{y}{r}.png');

  function zoomIn() {
    map.current.setZoom(map.current.getZoom() + 1);
    console.log('clicked')
  }

  function zoomOut() {
    map.current.setZoom(map.current.getZoom() - 1);
  }

  function fitFeature() {
    map.current.fitBounds(choro.current.getBounds())
  }

  function setBaseMap(base) {
    map.current.removeLayer(BaseMap.current);
    BaseMap.current = base;
    BaseMap.current.addTo(map.current);
  }

  function toggleMap(val) {
    // console.log(choro.current);
    if (map.current.hasLayer(choro.current)) {
      map.current.removeLayer(choro.current);
    } else {
      map.current.addLayer(choro.current);
    }
  }


  function CenterMap() {
    map.current.panTo(new L.LatLng(0.3265, 37.913));
  }

  const showStats = () => {
    if (chartHeight === '0px' && window.innerWidth > 1000) {
      setChartHeight('250px');
      setChartWidth('320px');
      setChartVisibilty('visible');
    } else if (chartHeight !== '0px' && window.innerWidth > 1000) {
      setChartHeight('0px');
      setChartWidth('320px');
      setChartVisibilty('hidden')
    } else if (chartHeight === '0px' && window.innerWidth < 1000) {
      setChartHeight('200px');
      setChartWidth('250px');
      setChartVisibilty('visible');
    } else {
      setChartHeight('0px');
      setChartWidth('250px');
      setChartVisibilty('hidden');
    }
  }

  function setMap() {
    if (choro.current != null) {
      map.current.removeLayer(choro.current);
    }

    if (map.current != null) {
      function getWidth(b) {
        let maximum = -Infinity;
        let minimum = Infinity;

        for (let num of b) {
          if (num > maximum) {
            maximum = num;
          }
          if (num < minimum) {
            minimum = num;
          }
        }
        var width = (maximum - minimum) / 7;
        return [width, minimum, maximum];
      }

      function getColor(d) {
        let a = Array;
        let range = getWidth(a);
        let width = range[0];
        let minimum = range[1];
        if (viz === 1) {
          return d > minimum + (width * 7) ? '#76520e' :
            d > minimum + (width * 6) ? '#926c15' :
              d > minimum + (width * 5) ? '#a47e1b' :
                d > minimum + (width * 4) ? '#b69121' :
                  d > minimum + (width * 3) ? '#c9a227' :
                    d > minimum + (width * 2) ? '#dbb42c' :
                      d > minimum + width ? '#edc531' :
                        '#ffe169';
        } else if (viz === 2) {
          return d > minimum + (width * 7) ? '#03045e' :
            d > minimum + (width * 6) ? '#023e8a' :
              d > minimum + (width * 5) ? '#0077b6' :
                d > minimum + (width * 4) ? '#0096c7' :
                  d > minimum + (width * 3) ? '#00b4d8' :
                    d > minimum + (width * 2) ? '#48cae4' :
                      d > minimum + width ? '#90e0ef' :
                        '#caf0f8';
        } else if (viz === 3) {
          return d > minimum + (width * 7) ? '#548c2f' :
            d > minimum + (width * 6) ? '#70960c' :
              d > minimum + (width * 5) ? '#87a70a' :
                d > minimum + (width * 4) ? '#9eb708' :
                  d > minimum + (width * 3) ? '#b5c806' :
                    d > minimum + (width * 2) ? '#ccd904' :
                      d > minimum + width ? '#e3e902' :
                        '#fafa00';
        } else if (viz === 4) {
          return d > minimum + (width * 7) ? '#3e2248' :
            d > minimum + (width * 6) ? '#3e2248' :
              d > minimum + (width * 5) ? '#5b3f64' :
                d > minimum + (width * 4) ? '#5b3f64' :
                  d > minimum + (width * 3) ? '#775c7f' :
                    d > minimum + (width * 2) ? '#93799a' :
                      d > minimum + width ? '#b096b6' :
                        '#ccb3d1';
        } else {
          return d > minimum + (width * 7) ? '#800026' :
            d > minimum + (width * 6) ? '#BD0026' :
              d > minimum + (width * 5) ? '#E31A1C' :
                d > minimum + (width * 4) ? '#FC4E2A' :
                  d > minimum + (width * 3) ? '#FD8D3C' :
                    d > minimum + (width * 2) ? '#FEB24C' :
                      d > minimum + width ? '#FED976' :
                        '#FFEDA0';
        }
      }

      function getWinner(d, e) {
        return d > e ? '#ffff00' : '#0000ff'
      }

      function lister() {
        let a = Array;
        let range = getWidth(a);
        let width = range[0];
        let minimum = range[1];
        let LArr = [];//legend Array
        LArr[0] = Math.floor(minimum)
        for (var i = 1; i <= 7; i++) {
          LArr.push(Math.floor(minimum + (width * i)));
        }
        return LArr;
      }

      function setFillColor(feature) {
        switch (viz) {
          case 0:
            return {
              fillColor: getWinner(feature.properties.Ruto, feature.properties.Odinga),
              weight: 1,
              opacity: 1,
              color: 'gray',
              dashArray: '3',
              fillOpacity: 0.9
            }
          case 1:
            return {
              fillColor: getColor(feature.properties.Ruto),
              weight: 1,
              opacity: 1,
              color: 'gray',
              dashArray: '3',
              fillOpacity: 0.9
            }
          case 2:
            return {
              fillColor: getColor(feature.properties.Odinga),
              weight: 1,
              opacity: 1,
              color: 'gray',
              dashArray: '3',
              fillOpacity: 0.9
            }
          case 3:
            return {
              fillColor: getColor(feature.properties.Wajackoyah),
              weight: 1,
              opacity: 1,
              color: 'gray',
              dashArray: '3',
              fillOpacity: 0.9
            }
          case 4:
            return {
              fillColor: getColor(feature.properties.Waihiga),
              weight: 1,
              opacity: 1,
              color: 'gray',
              dashArray: '3',
              fillOpacity: 0.9
            }
          case 5:
            return {
              fillColor: getColor(feature.properties.Total),
              weight: 1,
              opacity: 1,
              color: 'gray',
              dashArray: '3',
              fillOpacity: 0.9
            }
          case 6:
            return {
              fillColor: getColor(feature.properties.Registered),
              weight: 1,
              opacity: 1,
              color: 'gray',
              dashArray: '3',
              fillOpacity: 0.9
            }
          default:
            return {
              fillColor: getWinner(feature.properties.Ruto, feature.properties.Odinga),
              weight: 1,
              opacity: 1,
              color: 'gray',
              dashArray: '3',
              fillOpacity: 0.9
            }
        }
      }

      var info = L.control({ position: `topleft` });
      info.onAdd = function () {

        if (div2.current != null) {
          L.DomUtil.remove(div2.current)

        }
        div2.current = L.DomUtil.create('div', 'info');
        // create a div with a class "info"
        this._div = div2.current
        this.update();
        //this._div.update();
        return this._div;
      };



      // method that we will use to update the control based on feature properties passed
      //use a switch case to chnage the appearance of the values
      info.update = function (props) {
        switch (viz) {
          case 0:

            this._div.innerHTML = '<h4>Winner per County</h4>' + (props ?
              '<b>' + props.COUNTY + '</b><br /><b>Winner: </b>' + (props.Ruto > props.Odinga ? "<b>Ruto</b>" : "<b>Odinga</b>") +
              '<br /> <b>Ruto:\t </b>' + props.Ruto +
              '<br /> <b>Raila:\t </b>' + props.Odinga +
              '<br /> <b>Wajackoyah:\t </b>' + props.Wajackoyah +
              '<br /> <b>Mwaure:\t </b>' + props.Waihiga
              : 'Hover over a county');
            break;
          case 1:
            this._div.innerHTML = '<h4>William Ruto</h4>' + (props ?
              '<b>' + props.COUNTY + '</b><br />' + props.Ruto
              : 'Hover over a county');
            break;
          case 2:
            this._div.innerHTML = '<h4>Raila Odinga</h4>' + (props ?
              '<b>' + props.COUNTY + '</b><br />' + props.Odinga
              : 'Hover over a county');
            break;
          case 3:
            this._div.innerHTML = '<h4>George Wajackoyah</h4>' + (props ?
              '<b>' + props.COUNTY + '</b><br />' + props.Wajackoyah
              : 'Hover over a county');
            break;
          case 4:
            this._div.innerHTML = '<h4>Waihiga Mwaure</h4>' + (props ?
              '<b>' + props.COUNTY + '</b><br />' + props.Waihiga
              : 'Hover over a county');
            break;
          case 5:
            this._div.innerHTML = '<h4>Total Votes</h4>' + (props ?
              '<b>' + props.COUNTY + '</b><br />' + props.Total
              : 'Hover over a county');
            break;
          case 6:
            this._div.innerHTML = '<h4>Registered Voters</h4>' + (props ?
              '<b>' + props.COUNTY + '</b><br />' + props.Registered
              : 'Hover over a county');
            break;
          default:
            this._div.innerHTML = '<h4>William Ruto</h4>' + (props ?
              '<b>' + props.COUNTY + '</b><br />' + props.Ruto
              : 'Hover over a county');
            break;
        }
      };

      //create a legend
      var legend = L.control({ position: `bottomright` });
      legend.onAdd = function (map) {
        if (div.current != null) {
          L.DomUtil.remove(div.current)
        }
        div.current = L.DomUtil.create('div', 'legend');
        div.current.style.transition = 'all 4s ease 4s'
        div.current.innerHTML = "<h5>Legend</h5>"
        var grades = lister();

        // loop through our density intervals and generate a label with a colored square for each interval
        if (viz === 0) {
          div.current.innerHTML += '<li><i class="WRuto" style="background:#ffff00"></i><span class="winner">Kenya Kwanza</span></li> <li><i class="WRuto" style=" background:#0000ff"></i><span class="winner">Azimio</span></li>';
        } else {
          for (var i = 0; i < grades.length; i++) {
            div.current.innerHTML +=
              '<li><i style="background-color:' + getColor(grades[i] + 1) + '"></i> ' +
              grades[i] + (grades[i + 1] ? '&ndash;' + grades[i + 1] + '</li>' : '+');
          }
        }
        return div.current;
      };

      choro.current = L.geoJSON(county, {
        style: setFillColor,
        onEachFeature: onEachFeature
      });

      //function to highlight on hover
      function highlightFeature(e, feature) {
        var layer = e.target;
        layer.setStyle({
          weight: 2,
          color: '#666',
          dashArray: '',
          fillOpacity: 0.7
        });

        layer.bringToFront();
        info.update(layer.feature.properties);
      }

      info.addTo(map.current);
      legend.addTo(map.current);
      if (map.current.hasLayer(choro.current)) {
        map.current.removeLayer(choro.current);
      }
      if (choro.current != null) {
        map.current.addLayer(choro.current);
      }

      function resetHighlight(e) {
        choro.current.resetStyle(e.target);
        info.update();
      }

      function analyze() {
        if (chartHeight === '0px' && window.innerWidth > 1000) {
          setChartHeight('250px');
          setChartWidth('320px');
          setChartVisibilty('visible');
        } else if (chartHeight === '0px' && window.innerWidth < 1000) {
          setChartHeight('200px');
          setChartWidth('250px');
          setChartVisibilty('visible');
        }
      }
      //function for onclick
      function zoomToFeature(e) {
        // console.log(e.target.feature);
        let Arr = [e.target.feature.properties.COUNTY, e.target.feature.properties.Ruto, e.target.feature.properties.Odinga, e.target.feature.properties.Wajackoyah, e.target.feature.properties.Waihiga]
        e.target.bindPopup(`<div class='popup'>
        <span style="font-family:'Montserrat'; font-weight:bolder; font-size:12px; color:black;">${e.target.feature.properties.COUNTY}</span><br>
        <button class='popupbtn'>Analyze</button>
    </div>`).on('popupopen', function () {
          document.querySelector('.popupbtn').onclick = function () {
            setChartData(Arr);
            analyze();
          };
        }).openPopup();
      }



      //Implement the functions for each feature
      function onEachFeature(feature, layer) {
        layer.on({
          mouseover: highlightFeature,
          mouseout: resetHighlight,
          click: zoomToFeature
        })
      }

    }

  }

  useEffect(() => {
    let container = L.DomUtil.get('map');

    if (container != null) {
      container._leaflet_id = null
    }

    if (window.innerWidth <= 1540 && window.innerWidth >= 1000) {
      zoom.current = 6
    } else if (window.innerWidth < 1000) {
      zoom.current = 6
    } else {
      zoom.current = 7
    }
    if (map.current != null) CenterMap();

    if (map.current === null) {
      map.current = L.map('map', {
        center: [0.3265, 37.913],
        zoom: zoom.current,
        zoomControl: false
      })
      BaseMap.current = satellite;
      BaseMap.current.addTo(map.current)
      showStats();
    }


  }, [satellite, viz])
  setMap()
  useEffect(() => {
    setMap();
  }, [viz]);

  const showLayersSelector = () => {
    if (visibility === 'hidden') {
      
      setLayerWidth('200px');
      setVisibility('visible');
      setLayerOpacity('1')
    }else{
      setVisibility('hidden');
      setLayerWidth('0px');
      setLayerOpacity('0')
    } 
  }



  return (
    <ChartContext.Provider value={chartData}>
      <div className='map' id='map'>
        <div className='mapcontrol'>
          <button className='top' onClick={zoomIn}> <i className='fa fa-plus' aria-hidden='true'></i> </button>
          <button onClick={zoomOut}><i className='fa fa-minus' aria-hidden='true'></i></button>
          <button onClick={fitFeature}><i className='fa fa-arrows-alt' aria-hidden='true'></i></button>
          <button onClick={showStats}><i className='fa fa-bar-chart' aria-hidden='true'></i></button>
          <button className='bottom' onClick={showLayersSelector}><img src={layersicon} alt='layers' /></button>
        </div>
        <div className='layers' style={{ visibility: visibility, width:layerWidth}}>
          <div className='heading' style={{opacity:layerOpacity}}>
            <b>Select layers</b>
            <button onClick={showLayersSelector}>
              <i className="fa fa-times" aria-hidden="true"></i>
            </button>
          </div>
          <div className='layertiles' style={{opacity:layerOpacity}}>
            <div className='layerImg' onClick={() => { setBaseMap(OSM_TILE) }}>
              <img src={OSM} alt='OSM' />
              <b>OSM</b>
            </div>
            <div className='layerImg' onClick={() => { setBaseMap(satellite) }}>
              <img src={sat} alt='satellite' />
              <b>Satellite</b>
            </div>
            <div className='layerImg' onClick={() => { setBaseMap(NatGeo) }}>
              <img src={NGeo} alt='NatGeoWorldMap' />
              <b>NatGeo</b>
            </div>
          </div>
          <div className="mapcheck" style={{opacity:layerOpacity}}>
            <span style={{ fontWeight: 'bold' }}>Show Map</span>
            <Switch defaultChecked inputProps={{ 'aria-label': 'controlled' }} onChange={toggleMap} />
          </div>

        </div>
        <div className='Chart' style={{ height: chartHeight, width: chartWidth, visibility: chartVisibilty }}>
          <div className='heading'>
            <b>{chartData[0]}</b>
            <div style={{ height: "100%", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
              <button onClick={() => { setChartData(["Total(%)", 50.49, 48.85, 0.44, 0.23]) }} style={{ marginRight: "5px" }}>
                <i className="fa fa-home" aria-hidden="true"></i>
              </button>
              <button onClick={showStats}>
                <i className="fa fa-times" aria-hidden="true"></i>
              </button>
            </div>

          </div>
          <div className="BarChart">
            <div className="chartlegend">
              <li><i style={{ background: '#ffff00' }}></i>{' '} Ruto</li>
              <li><i style={{ background: '#0000ff' }}></i> Raila</li>
              <li><i style={{ background: 'rgb(64,145,108)' }}></i> Wajackoyah</li>
              <li><i style={{ background: 'rgb(94,84,142)' }}></i> Mwaure</li>
            </div>
            <BarChart />
          </div>
        </div>
      </div>
      {/* <div className="bottomNav">
        <button onClick={showStats}><i className='fa fa-bar-chart' aria-hidden='true'></i></button>
        <button onClick={showLayersSelector}><img src={layersicon} alt='layers' /></button>
      </div> */}
    </ChartContext.Provider>

  );
}